/**
 * 客户回款，银行登记单 详情页面配置
 * @author zjs
 * @time 2017-10-26
 */
export default {
    data () {
        return {
            infoConfig : [
                
                {"label":"流水号","prop":"transaction_no_display"},
                {"label":"业务日期","prop":"trade_time"},
                {"label":"收支类型","prop":"payment_type_str"},
                {"label":"账户名称","prop":"account_name"},
                {"label":"收支金额","prop":"amount"},
                {"label":"收款账号","prop":"account_number"},
                {"label":"制单人","prop":"clerk_name"},
                {"label":"摘要","prop":"zhaiyao", 'colspan': '3'}
            ], // 详情信息的配置
            customerConfig: {
                config: {
                    isNumber: true
                },
                head: [
                    {
                        "prop": "customer_account",
                        "label": "客户编码"
                    }, {
                        "prop": "customer_name",
                        "label": "客户名称"
                    }, {
                        "prop": "huikuan_amount",
                        "label": "实收/实退金额"
                    }, {
                        "prop": "shouxufei",
                        "label": "手续费"
                    }, {
                        "prop": "weidu_name",
                        "label": "核算纬度"
                    }, {
                        "prop": "employee_name",
                        "label": "单据业务员"
                    }, {
                        "prop": "tag",
                        "label": "备注"
                    }
                ]
            } // 客户列表的配置
        }
    }
}